import { useSelector } from "react-redux";
import { permissionsSelector } from "store/bailiff/auth/base_auth.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useClaimToken = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const claim = useSelector(permissionsSelector);
  const permissions = claim ? JSON.parse(claim)?.operators : [];

  console.log({ permissions });
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { permissions };
};
